/**
 * mixology.js
 * - Loads products for chosen vendor
 * - Fetches product JSON to get first variant id for cart properties where needed
 * - Enforces total percent == 100 and at least 2 non-zero slots
 * - Updates SVG bottle fill and total percentage text
 * - Submits standard cart add form (single variant id set in hidden input)
 */

document.addEventListener('DOMContentLoaded', () => {
  // Scoped per-section so multiple sections won't conflict
  document.querySelectorAll('.mixology-section').forEach((section) => {
    const form = section.querySelector('.mixology-form');
    const addButton = section.querySelector('.mix-add-btn');
    const errorBox = section.querySelector('.mix-error');
    const mixVariantInput = section.querySelector('#mix-product-variant');
    const slots = Array.from(section.querySelectorAll('.mix-slot'));
    const flaskFill = section.querySelector('.mix-fill');
    const flaskText = section.querySelector('.mix-total-text');

    // Helper: parse product handle from product url (/products/handle)
    function handleFromUrl(url) {
      if (!url) return null;
      try {
        const urlObj = new URL(url, window.location.origin);
        const parts = urlObj.pathname.split('/');
        if (parts.length >= 3 && parts[1] === 'products') return parts[2];
      } catch (e) {
        const parts = url.split('/');
        const idx = parts.indexOf('products');
        if (idx !== -1 && parts.length > idx + 1) return parts[idx + 1];
      }
      return null;
    }

    /* Update SVG bottle fill and central percentage
    function updateFlask(total) {
      const pct = Math.max(0, Math.min(100, total));
      const translate = 100 - pct;
      if (flaskFill) flaskFill.style.transform = `translateY(${translate}%)`;
      if (flaskText) flaskText.textContent = `${pct}%`;
    } */

      function updateFlask(total) {
  const pct = Math.max(0, Math.min(100, total));
  const translate = 100 - pct;

  // Old SVG rect (ok to keep if present)
  if (flaskFill) flaskFill.style.transform = `translateY(${translate}%)`;
  if (flaskText) flaskText.textContent = `${pct}%`;

  // NEW: move the clipped liquid group
  const liquidLevel = section.querySelector('.mrk-liquid-level');
  const percentEl = section.querySelector('.mrk-final-percent');
  if (liquidLevel) liquidLevel.style.transform = `translateY(${translate}%)`;
  if (percentEl) percentEl.textContent = `${pct}%`;

     
  

        if (total === 0) total = -1;
         section.querySelectorAll(".mrk-water-wave").forEach(el => {
  el.style.transform = `translate(0px, ${100 - total}%)`;
});
} 

  

 // --- helpers ---
function getValues() {
  return slots.map(s => parseInt(s.querySelector('.slot-range').value, 10) || 0);
}
function sum(arr) {
  return arr.reduce((a, b) => a + b, 0);
}

/**
 * Cap the currently active range so total never exceeds 100.
 * Returns the new total after capping.
 */
function capActiveTo100(activeRangeEl) {
  const values = getValues();
  const idx = slots.findIndex(s => s.contains(activeRangeEl));
  if (idx === -1) return sum(values);

  const desired = parseInt(activeRangeEl.value, 10) || 0;
  const totalOthers = values.reduce((a, v, i) => a + (i === idx ? 0 : v), 0);
  const remaining = Math.max(0, 100 - totalOthers);
  const capped = Math.min(desired, remaining);

  if (capped !== desired) {
    activeRangeEl.value = capped;
  }
  return totalOthers + capped;
}

// --- validation & UI state ---
function validateAndToggle() {
  const values = getValues();
  const total = sum(values);
  const nonZeroCount = values.filter(v => v > 0).length;

  // bottle / wave update
  updateFlask(total);

  // default state
  addButton.disabled = true;
  errorBox.textContent = '';

  if (total === 100 && nonZeroCount >= 2) {
    // ready to add
    addButton.disabled = false;
    return true;
  }

  // not ready
  if (total !== 100) {
      const lang = (document.documentElement.lang || '').toLowerCase();
    const isArabic = lang === 'ar' || lang.startsWith('ar-');
    const checkText  = isArabic ? 'يجب أن يساوي المجموع %100' : 'Total must equal 100%';
    const checkText2  = isArabic ? 'اختر عطرين على الأقل بنسب غير صفرية.': 'Select at least two fragrances with non-zero percentages';

    errorBox.textContent = checkText;
  } else if (nonZeroCount < 2) {
    errorBox.textContent = checkText2 ;
  }
  return false;
}

 

  function loadProductsForVendor(brand, productSelect) {
   const lang = (document.documentElement.lang || '').toLowerCase();
  const isArabic = lang === 'ar' || lang.startsWith('ar-');
  const emptyText  = isArabic ? 'لا توجد منتجات متاحة' : 'No active products';

    productSelect.innerHTML = `<option value="">${window.themeStrings.selectFragrance}</option>`;
    
    const products = productsByBrand[brand] || [];
    
    if (products.length === 0) {
      productSelect.innerHTML = `<option value="">${emptyText}</option>`;
      productSelect.disabled = true;
      return;
    }

    products.forEach(p => {
      const opt = document.createElement('option');
      opt.value = p.handle;
      opt.textContent = p.title;
      opt.dataset.prodId = p.id;
      productSelect.appendChild(opt);
    });
    
    productSelect.disabled = false;
  }

    // Load products by vendor
 /* async function loadProductsForVendor(vendor, productSelect) {
      productSelect.innerHTML = `<option value="">Loading...</option>`;
      productSelect.disabled = true;
      if (!vendor) {
        productSelect.innerHTML = `<option value="">Select Fragrance</option>`;
        return;
      }

      try {
        const q = encodeURIComponent(vendor);
        const resp = await fetch(`/search/suggest.json?q=${q}&resources[type]=product`);
        if (!resp.ok) throw new Error('Network response not ok');
        const data = await resp.json();
        const results = (data.resources && data.resources.results && data.resources.results.products) || [];
        const products = results.filter(p => (p.vendor === vendor || (p.vendor && p.vendor.toLowerCase() === vendor.toLowerCase())) && p.available);

        if (products.length === 0) {
          productSelect.innerHTML = `<option value="">No active products</option>`;
          productSelect.disabled = true;
          return;
        }

        productSelect.innerHTML = `<option value="">Select Fragrance</option>`;
        products.forEach(p => {
          const handle = p.handle || (p.url ? handleFromUrl(p.url) : null);
          const opt = document.createElement('option');
          opt.value = handle || p.id || p.url || p.title;
          opt.textContent = p.title;
          if (p.id) opt.dataset.prodId = p.id;
          if (p.vendor) opt.dataset.vendor = p.vendor;
          productSelect.appendChild(opt);
        });

        productSelect.disabled = false;
      } catch (err) {
        console.error(err);
        productSelect.innerHTML = `<option value="">Error loading products</option>`;
        productSelect.disabled = true;
      }
    } */

    // Handle product selection
    async function handleProductSelect(productSelect, slotEl) {
      const selected = productSelect.options[productSelect.selectedIndex];
      const value = selected ? selected.value : '';
      const hiddenId = slotEl.querySelector('.slot-product-id');
      const hiddenTitle = slotEl.querySelector('.slot-product-title');
      const hiddenVendor = slotEl.querySelector('.slot-product-vendor');

      hiddenId.value = '';
      hiddenTitle.value = '';
      hiddenVendor.value = '';

      if (!value) return;

      try {
        const maybeHandle = value;
        let productJson = null;
        if (typeof maybeHandle === 'string' && maybeHandle.indexOf('/') === -1 && maybeHandle.length > 0) {
          const resp = await fetch(`/products/${encodeURIComponent(maybeHandle)}.js`);
          if (resp.ok) productJson = await resp.json();
        }

        if (!productJson) {
          hiddenTitle.value = selected.textContent || '';
          hiddenVendor.value = selected.dataset.vendor || '';
          hiddenId.value = selected.dataset.prodId || '';
          return;
        }

        hiddenTitle.value = productJson.title || '';
        hiddenVendor.value = productJson.vendor || '';
        hiddenId.value = productJson.id || '';
      } catch (err) {
        console.error('Failed to load product JSON', err);
        hiddenTitle.value = selected.textContent || '';
        hiddenVendor.value = selected.dataset.vendor || '';
        hiddenId.value = selected.dataset.prodId || '';
      }
    }

    // Enable/disable one slot's slider. When disabling, reset value to 0 and sync UI.
function setRangeEnabled(slotEl, enabled) {
  const range = slotEl.querySelector('.slot-range');
  const bubble = slotEl.querySelector('.slot-percent-value');
  const hiddenPercent = slotEl.querySelector('.slot-percent');

  range.disabled = !enabled;

  if (!enabled) {
    range.value = 0;
    if (bubble) bubble.textContent = '0%';
    if (hiddenPercent) hiddenPercent.value = '0';
  }
}


   slots.forEach(slot => {
  const vendorSelect   = slot.querySelector('.vendor-select');
  const productSelect  = slot.querySelector('.product-select');
  const range          = slot.querySelector('.slot-range');
  const bubble         = slot.querySelector('.slot-percent-value');
  const hiddenPercent  = slot.querySelector('.slot-percent');

  // Initial state: disabled until a product is selected
  setRangeEnabled(slot, !!(productSelect && productSelect.value));

  // Vendor change → load products and (temporarily) disable the slider
  vendorSelect.addEventListener('change', (e) => {
    const vendor = e.target.value;
    // If vendor cleared, also clear product, disable slider, zero it
    if (!vendor) {
      if (productSelect) {
        productSelect.innerHTML = `<option value="">Select Fragrance</option>`;
        productSelect.disabled = true;
      }
      setRangeEnabled(slot, false);
      updateFlask(sum(getValues()));
      validateAndToggle();
      return;
    }

    // Vendor chosen → fetch products then keep slider disabled until product actually chosen
    loadProductsForVendor(vendor, productSelect).then(() => {
      setRangeEnabled(slot, !!productSelect.value);
      updateFlask(sum(getValues()));
      validateAndToggle();
    });
  });

  // Product change → enable if value present, otherwise disable & zero out
  productSelect.addEventListener('change', () => {
    const hasProduct = !!productSelect.value;
    setRangeEnabled(slot, hasProduct);
    updateFlask(sum(getValues()));
    validateAndToggle();
  });

  // Live update while dragging, with 100% cap
  const updateRange = () => {
    if (range.disabled) return; // ignore disabled sliders

    // 1) live-cap the active slider so sum never exceeds 100
    const total = capActiveTo100(range);

    // 2) sync UI for this slot
    const val = parseInt(range.value, 10) || 0;
    bubble.textContent = `${val}%`;
    hiddenPercent.value = String(val);

    // 3) update bottle + enable/disable add button
    updateFlask(total);
    validateAndToggle();
  };

  range.addEventListener('input', updateRange);
  range.addEventListener('change', updateRange);
});

    // -----------------------------
// 🧾 Form submit (Name + Mix Details — read directly from selects)
// -----------------------------
form.addEventListener('submit', (e) => {
  e.preventDefault();
  errorBox.textContent = '';

  if (!validateAndToggle()) return;

  const mixVariant = mixVariantInput.value && mixVariantInput.value.trim();
  if (!mixVariant) {
    errorBox.textContent = 'Mix product variant id is not set. Please configure section settings.';
    return;
  }

  // Ensure hidden variant input
  let idInput = form.querySelector('input[name="id"]');
  if (!idInput) {
    idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    form.appendChild(idInput);
  }
  idInput.value = mixVariant;

  // Read scent name BEFORE we clear properties
  const scentNameField = form.querySelector('input[name="properties[Name Your Scent]"]');
  const scentName = (scentNameField?.value || '').trim();

  // --- Collect slot data directly from selects (do this BEFORE removing properties) ---
  const lines = [];
  let total = 0;

  slots.forEach((slot, i) => {
    const rangeEl = slot.querySelector('.slot-range');
    const percent = parseInt(rangeEl?.value || '0', 10) || 0;
    total += percent;
    if (percent <= 0) return;

    const vendorSel   = slot.querySelector('.vendor-select');
    const productSel  = slot.querySelector('.product-select');
    const selected    = productSel?.options?.[productSel.selectedIndex];

    // Prefer product option's vendor dataset; fallback to vendor select value
    const brand = (selected?.dataset?.vendor || vendorSel?.value || '').trim();
    // Product name from option text
    const productNameRaw = (selected?.textContent || '').trim();
    if (!brand || !productNameRaw) return;

    const cleanProduct = productNameRaw.replace(/\s*\d+\s*ml\s*/i, '').trim();
    lines.push(`${brand}'s - ${i + 1}: ${cleanProduct} ${percent}%`);
  });

  // --- Now it's safe to clear existing properties and re-add only what we want ---
  form.querySelectorAll('[name^="properties["]').forEach(el => el.remove());

  if (scentName) {
    const scentInput = document.createElement('input');
    scentInput.type = 'hidden';
    scentInput.name = 'properties[Name Your Scent]';
    scentInput.value = scentName;
    form.appendChild(scentInput);
  }

  // Add combined Mix Details (no extra "Mix Details:" header in the value)
  if (lines.length > 0) {
    const detailsInput = document.createElement('input');
    detailsInput.type = 'hidden';
    detailsInput.name = 'properties[Mix Details]';
    detailsInput.value = lines.join('\n');
    form.appendChild(detailsInput);
  }

  // Optional: total percent sanity
  const totalProp = document.createElement('input');
  totalProp.type = 'hidden';
  totalProp.name = 'properties[Mix Total Percent]';
  totalProp.value = `${total}%`;
  form.appendChild(totalProp);

  // ---- Submit via AJAX ----
  const formData = new FormData(form);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: { 'Accept': 'application/json' }
  })
  .then(r => {
    if (!r.ok) throw r;
    return r.json();
  })
  .then(() => {
    window.location.href = '/cart';
  })
  .catch(async (err) => {
    console.error(err);
    try {
      const text = await err.text();
      errorBox.textContent = 'Failed to add to cart.';
    } catch {
      errorBox.textContent = 'Failed to add to cart.';
    }
  });
});

    // Initial validation
    validateAndToggle();
  }); // end each section
});